export const getIsExternalLink = (link: string, domain: string): boolean =>
  Boolean(
    (link.startsWith('http') && !link.includes(domain)) ||
      link.startsWith('tel:') ||
      link.startsWith('mailto:'),
  );

export const getLink = (link: string, domain: string) => {
  const linkIncludingDomain =
    link.startsWith('http') &&
    link.includes(domain) &&
    link.split(domain).pop();

  return linkIncludingDomain || link;
};
